"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrAddEntry = getOrAddEntry;
exports.objectKeys = objectKeys;
function getOrAddEntry(key, record, factory) {
    let entity = record[key];
    if (!entity) {
        entity = factory(key);
        record[key] = entity;
    }
    return entity;
}
function objectKeys(obj) {
    return Object.keys(obj);
}
//# sourceMappingURL=lib.js.map